import React from 'react';
import { Box, Tab, Tabs, tabsClasses } from '@mui/material';
import { useSelector } from 'react-redux';
import { IAppReduxStore } from '../../../../../redux/store';
import { getForwardTabs, getReleaseTabs } from '../../../../../redux/project/sliceProjectWorkflow';
import { mdiCheckCircle } from '@mdi/js';
import Icon from '@mdi/react';
import { headingFontBold, vars } from '../../../../../Theme';
import AppTooltip from '../../../AppTooltip/AppTooltip';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

const tabsSx = {
    padding: 0,
    alignItems: 'center',
    '.MuiTabs-indicator': {
        display: 'none',
    },
    [`& .${tabsClasses.scrollButtons}`]: {
        '&.Mui-disabled': { display: 'none' },
        width: '24px',
        height: '24px',
        borderRadius: '4px',
        color: vars.font,
        ':hover': {
            backgroundColor: vars.fillGray,
        },
    },
};

const tabSx = {
    ...headingFontBold,
    textTransform: 'none',
    fontSize: 16,
    color: vars.font,
    minHeight: 0,
    p: 0,
    mr: '16px',
    ':hover': {
        cursor: 'default',
    },
    '& .MuiTab-icon': {
        mb: 0,
        mx: 0.5,
        width: '24px',
        height: '24px',
    },
};

const tabLabelSx = {
    whiteSpace: 'nowrap',
    textTransform: 'none',
};

export default () => {
    /** Configure component translation. */
    const namespace = 'translations';
    const { t, i18n } = useTranslation(namespace, { keyPrefix: 'initialReleaseDialog' });

    const { areaName } = useParams();

    const selectedTab = useSelector((_store: IAppReduxStore) =>
        areaName === 'import'
            ? _store.projectWorkflow.selectedReleaseTab
            : _store.projectWorkflow.selectedTab,
    );
    const tabs = useSelector(areaName === 'import' ? getReleaseTabs : getForwardTabs);

    const getIconColor = tab => {
        if (tab.isDisabled) return vars.lightGray;
        if (tab.isCompleted) return vars.brandGreen;
        return vars.lightGray;
    };

    const getTabTitle = title => {
        return title.length > 20 ? title.substring(0, 20) + '...' : title;
    };

    const getTranslatedTitle = (name: string, addedIndex) => {
        const translatedName = i18n.exists(
            `${namespace}${i18n.options.nsSeparator}initialReleaseDialog.${name}`,
        )
            ? t(name)
            : name;
        const indexSuffix = addedIndex ? ` (${addedIndex})` : '';
        return `${translatedName}${indexSuffix}`;
    };

    return (
        <>
            {tabs && (
                <Tabs variant='scrollable' value={selectedTab} sx={tabsSx}>
                    {tabs.map(tab => {
                        return (
                            <AppTooltip
                                key={tab.key}
                                title={getTranslatedTitle(tab.name, tab.index)}
                                placement='top'
                            >
                                <Tab
                                    key={tab.key}
                                    icon={
                                        tab.name ? (
                                            <Icon
                                                path={mdiCheckCircle}
                                                size={'20px'}
                                                color={getIconColor(tab)}
                                            />
                                        ) : null
                                    }
                                    label={
                                        <Box sx={tabLabelSx}>
                                            {getTabTitle(getTranslatedTitle(tab.name, tab.index))}
                                        </Box>
                                    }
                                    iconPosition='end'
                                    sx={tabSx}
                                    disabled={tab.isDisabled}
                                />
                            </AppTooltip>
                        );
                    })}
                </Tabs>
            )}
        </>
    );
};
